var map = {
	"./ABW.gif": "8ee2",
	"./AFG.gif": "896b",
	"./AGO.gif": "685c",
	"./ALB.gif": "77bf",
	"./AND.gif": "557f",
	"./ARE.gif": "eaea",
	"./ARG.gif": "04dd",
	"./ARM.gif": "44d9",
	"./AUS.gif": "12124",
	"./AUT.gif": "8e75",
	"./AZE.gif": "bf9c",
	"./BDI.gif": "06c9",
	"./BEL.gif": "6cb4",
	"./BEN.gif": "182d",
	"./BFA.gif": "acf9",
	"./BGD.gif": "4f7b",
	"./BGR.gif": "9988",
	"./BHR.gif": "df74",
	"./BHS.gif": "f6c4",
	"./BIH.gif": "65e3",
	"./BLR.gif": "2d9b",
	"./BLZ.gif": "1060",
	"./BMU.gif": "6667",
	"./BOL.gif": "92f6",
	"./BRA.gif": "8db2f",
	"./BRB.gif": "2782",
	"./BRN.gif": "5533",
	"./BTN.gif": "a8b3",
	"./BWA.gif": "86d2",
	"./CAF.gif": "6009",
	"./CAN.gif": "fd52",
	"./CDF.gif": "a032",
	"./CHE.gif": "d162",
	"./CHL.gif": "23db",
	"./CHN.gif": "a02a",
	"./CIV.gif": "99f8",
	"./CMR.gif": "e84a",
	"./COD.gif": "58fe",
	"./COG.gif": "856a",
	"./COK.gif": "733d",
	"./COL.gif": "58c6",
	"./COM.gif": "a864",
	"./CPV.gif": "182f",
	"./CRI.gif": "20b6",
	"./CUB.gif": "0b69",
	"./CYM.gif": "5208",
	"./CYP.gif": "37e7",
	"./CZE.gif": "e81a",
	"./DEU.gif": "b39b",
	"./DJI.gif": "dc2d",
	"./DNK.gif": "aeea",
	"./DOM.gif": "76c8",
	"./DZA.gif": "3300",
	"./ECU.gif": "32b5",
	"./EGY.gif": "ecf4",
	"./ESP.gif": "702e",
	"./EST.gif": "9655",
	"./ETH.gif": "429a",
	"./EUR.gif": "487a",
	"./FIN.gif": "f200",
	"./FJI.gif": "8d83",
	"./FRA.gif": "21e0",
	"./GAB.gif": "c32d",
	"./GBR.gif": "e4f3",
	"./GEO.gif": "2947",
	"./GHA.gif": "aa5d",
	"./GIN.gif": "71cd",
	"./GMB.gif": "8f1f",
	"./GNB.gif": "20a0",
	"./GNQ.gif": "4085",
	"./GRC.gif": "fd8f",
	"./GRD.gif": "7add",
	"./GTM.gif": "56de",
	"./GUM.gif": "83b4",
	"./GUY.gif": "b6a2",
	"./HKG.gif": "fd8d",
	"./HND.gif": "1691",
	"./HRV.gif": "61d2",
	"./HTI.gif": "179b",
	"./HUN.gif": "83c5",
	"./IDN.gif": "e33f",
	"./IND.gif": "03ce",
	"./IRL.gif": "8c3c",
	"./IRN.gif": "a6e2",
	"./IRQ.gif": "36a8",
	"./ISL.gif": "1b86",
	"./ISR.gif": "c102",
	"./ITA.gif": "3f86",
	"./JAM.gif": "c7d3",
	"./JOR.gif": "adc2",
	"./JPN.gif": "0503",
	"./KAZ.gif": "e155",
	"./KEN.gif": "0054",
	"./KGZ.gif": "69c2",
	"./KHM.gif": "916f",
	"./KIR.gif": "6655",
	"./KNA.gif": "c39d",
	"./KOR.gif": "8367",
	"./KWT.gif": "6108",
	"./LAO.gif": "5972",
	"./LBN.gif": "f992",
	"./LBR.gif": "1e68",
	"./LBY.gif": "94bb",
	"./LCA.gif": "2fb4",
	"./LIE.gif": "2a82",
	"./LKA.gif": "2184",
	"./LSO.gif": "da5c",
	"./LUX.gif": "d173",
	"./LVA.gif": "1a2c",
	"./MAC.gif": "d05a",
	"./MAR.gif": "a67c",
	"./MCO.gif": "afe9",
	"./MDA.gif": "0e79",
	"./MDG.gif": "99ef",
	"./MDV.gif": "7054",
	"./MEX.gif": "d19b",
	"./MHL.gif": "b8a4",
	"./MKD.gif": "36e8",
	"./MLI.gif": "e056",
	"./MLT.gif": "dcf1",
	"./MNE.gif": "4aba",
	"./MNG.gif": "2975",
	"./MOZ.gif": "e2cc",
	"./MRT.gif": "1ba9",
	"./MUS.gif": "b86d",
	"./MWI.gif": "d5a0",
	"./MYS.gif": "318d",
	"./NAM.gif": "3659",
	"./NER.gif": "2d31",
	"./NGA.gif": "e8bf",
	"./NIC.gif": "ee54",
	"./NLD.gif": "e1b1",
	"./NOR.gif": "c8be",
	"./NPL.gif": "baa0",
	"./NRU.gif": "58ef",
	"./NZL.gif": "ded9",
	"./OMN.gif": "15dc",
	"./PAK.gif": "215f",
	"./PAN.gif": "4b93",
	"./PER.gif": "6d99",
	"./PHL.gif": "50b9",
	"./PLW.gif": "99c2",
	"./PNG.gif": "67b9",
	"./POL.gif": "1499",
	"./PRI.gif": "7e8f",
	"./PRK.gif": "cbcf",
	"./PRT.gif": "24e5",
	"./PRY.gif": "aebc",
	"./PSE.gif": "126e",
	"./QAT.gif": "bb46",
	"./ROU.gif": "9dcb",
	"./RUS.gif": "750f",
	"./RWA.gif": "dd30",
	"./SAU.gif": "05c6",
	"./SDN.gif": "e43d",
	"./SEN.gif": "41fa",
	"./SGP.gif": "a132",
	"./SLB.gif": "e1db",
	"./SLE.gif": "a338",
	"./SLV.gif": "6ef6",
	"./SMR.gif": "1a70",
	"./SOM.gif": "8383",
	"./SRB.gif": "33b0",
	"./SSD.gif": "e20e",
	"./STP.gif": "b2532",
	"./SUR.gif": "9dbc",
	"./SVK.gif": "87e6",
	"./SVN.gif": "daa8",
	"./SWE.gif": "7e1c",
	"./SWZ.gif": "6a77",
	"./SYC.gif": "9fb2",
	"./SYR.gif": "b3e0",
	"./TCD.gif": "4186",
	"./TGO.gif": "f941",
	"./THA.gif": "43a9",
	"./TJK.gif": "4a74",
	"./TKM.gif": "d23b",
	"./TLS.gif": "e715",
	"./TON.gif": "db6a",
	"./TTO.gif": "6563",
	"./TUN.gif": "da62",
	"./TUR.gif": "6014",
	"./TUV.gif": "4dc5",
	"./TWN.gif": "66d8",
	"./TZA.gif": "1ed6",
	"./UGA.gif": "e110",
	"./UKR.gif": "adcf",
	"./URY.gif": "1c1e",
	"./USA.gif": "0df66",
	"./UZB.gif": "e8cc",
	"./VEN.gif": "fa00",
	"./VGB.gif": "b613",
	"./VIR.gif": "a2ea",
	"./VNM.gif": "87b7",
	"./VUT.gif": "f48f",
	"./WSM.gif": "e22c",
	"./XAF.gif": "0e25",
	"./XCD.gif": "460f",
	"./XOF.gif": "3c89",
	"./XPF.gif": "1e0c",
	"./YEM.gif": "f6e6",
	"./ZAF.gif": "bcd3",
	"./ZMB.gif": "d079",
	"./ZWE.gif": "1630",
	"./money.gif": "0df9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "085f";